export default {
  items: [
    {
      name: 'Locations',
      url: '/locations',
    },
    {
      name: 'Verify Menu',
      url: '/menu/verify',
    },
    {
      name: 'Update Menu',
      url: '/menu/update',
    },
    {
      name: 'Analytics',
      url: '/analytics',
      badge: {
        variant: 'info',
        text: 'New!'
      }
    },
    // {
    //   name: 'Ads',
    //   url: '/ads',
    // },    
    {
      name: 'Tools and Embed',
      url: '/tools',
    },
    {
      name: 'Account',
      url: '/account',
    },
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js